import { IGNORED_BASE } from 'components/atoms/SideMenuBreadcrumb/consts';

export const getPathSnippetsWithoutBaseLocation = (pathname: string) =>
    pathname
        .split('/')
        .filter(Boolean)
        .filter((pathSnippet) => pathSnippet !== IGNORED_BASE);
